<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-toolbar flat dense color="primary" dark>
            <v-toolbar-title>
              {{ $tc('models.subscription', 2) }}
            </v-toolbar-title>
            <v-spacer />
            <meta-button
              v-if="can('create', 'user')"
              type="new"
              @click="setNewSubscription = true"
            />
            <dialog-new-subscription
              :id="id"
              v-model="setNewSubscription"
              :pay="true"
              :type-member="'user'"
            />
            <v-btn v-if="id" icon dark :loading="loading" @click="init">
              <v-icon>refresh</v-icon>
            </v-btn>
          </v-toolbar>
          <!-- <v-toolbar card flat dense color="white">
            <v-text-field
              v-model="match"
              flat
              hide-details
              :placeholder="$t('action.buttons.search')"
              prepend-icon="search"
              solo
            >
            </v-text-field>
          </v-toolbar> -->
          <v-divider />
          <v-card-text class="pa-0">
            <v-data-table
              :headers="headers"
              :items="formatedList"
              disable-initial-sort
              :loading="loading"
              :rows-per-page-items="[8]"
              :pagination.sync="pagination"
              :total-items="totalItems"
            >
              <template slot="items" slot-scope="props">
                <td>{{ props.item.typeSubscription || '--' }}</td>
                <td>{{ props.item.typePayment }}</td>
                <td class="text-xs-center">
                  {{ props.item.startAt || '--' }}
                </td>
                <td class="text-xs-center">
                  {{ props.item.expireAt || '--' }}
                </td>
                <td class="text-xs-center">
                  <button-state
                    :state="!!(!props.item.expired || props.item.status)"
                  />
                </td>
                <td>
                  {{ getStorage(props.item) }}
                </td>
                <td class="text-xs-center">
                  <button-state :state="!!props.item.isTrial" />
                </td>
                <td class="text-xs-center">
                  <v-btn
                    flat
                    icon
                    color="primary"
                    @click="onLinkedAccounts(props.item._id)"
                  >
                    <v-icon>visibility</v-icon>
                  </v-btn>
                </td>
                <td class="text-xs-center">
                  <v-btn
                    v-if="props.item.invoiceUrl"
                    flat
                    icon
                    color="primary"
                    @click="onInvoice(props.item.invoiceUrl)"
                  >
                    <v-icon>visibility</v-icon>
                  </v-btn>

                  <span v-else>--</span>
                </td>
                <td class="text-xs-center">
                  {{ formatedName(props.item.createdBy[0]) || '--' }}
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <dialog-linked-accounts
      v-model="dialogLinkedAccounts"
      :subscription-id="subscriptionId"
    />
  </v-container>
</template>

<script>
import DialogLinkedAccounts from '@/components/widgets/dialog/DialogLinkedAccounts'
import DialogNewSubscription from '@/components/widgets/dialog/DialogNewSubscription'
import { apiAxios, parseFilters } from '@/helpers'
import { formatDate } from '@/helpers/dateHelper'

export default {
  name: 'TabSubscriptions',
  components: { DialogNewSubscription, DialogLinkedAccounts },
  props: {
    id: { type: String, required: false, default: '' },
  },
  data() {
    return {
      match: '',
      loading: false,
      subscriptionId: '',
      dialogLinkedAccounts: false,
      setNewSubscription: false,
      items: [],
      pagination: {
        hasMore: false,
        page: 1,
        rowsPerPage: 10,
      },
      totalItems: 0,
    }
  },
  // created() {
  //   this.init()
  // },
  computed: {
    headers() {
      let headers = [
        {
          text: this.$tc('models.typeSubscription'),
          value: 'typeSubscription',
          sortable: false,
        },
        {
          text: this.$tc('fields.typeSubscriptions.typePayment'),
          value: 'typePayment',
          sortable: false,
        },
        {
          text: this.$t('fields.subscriptions.startAt'),
          value: 'startAt',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('fields.subscriptions.expireAt'),
          value: 'expireAt',
          align: 'center',
          sortable: false,
        },

        {
          text: this.$t('titles.matches.status'),
          value: 'status',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('titles.users.usedStorage'),
          value: 'usedStorage',
        },
        {
          text: this.$t('fields.subscriptions.isTrial'),
          value: 'isTrial',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('fields.typeSubscriptions.linkedAccounts'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('titles.global.invoice'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('titles.global.assignedBy'),
          value: 'createdBy',
          align: 'center',
          sortable: false,
        },
      ]

      return headers
    },
    formatedList() {
      return this.items.map((item) => ({
        ...item,
        startAt: formatDate(item.startAt, true),
        expireAt: formatDate(item.expireAt, true),
        createdAt: formatDate(item.createdAt, true),
        typePayment: item.typePayment
          ? this.$t(
              `fields.typeSubscriptions.typesPayment.${
                item.typePayment.split('-')[0]
              }`
            )
          : '--',
      }))
    },
  },
  watch: {
    id() {
      this.clear()
      this.init()
    },
    pagination: {
      handler: function () {
        this.init()
      },
      deep: true,
    },
  },
  mounted() {
    this.clear()
    this.init()
  },
  methods: {
    async init() {
      if (this.id) {
        this.loading = true
        let { body, query } = parseFilters(
          { pagination: this.pagination },
          { entityId: this.id }
        )

        const { data } = await apiAxios
          .post(`subscriptions/format`, body, { params: { ...query } })
          .finally(() => {
            this.loading = false
          })
        this.totalItems = data.paginate ? data.paginate.totalData : 0

        this.items = data.data ? data.data.subscription : []
      }
    },
    getStorage(item) {
      let { usedStorage, typeSubscriptionStorage } = item
      return `${usedStorage} / ${typeSubscriptionStorage} MB`
    },
    onLinkedAccounts(subscriptionId) {
      this.subscriptionId = subscriptionId
      this.dialogLinkedAccounts = true
    },
    onInvoice(invoiceUrl) {
      var win = window.open(invoiceUrl, '_blank')
      win.focus()
    },
    clear() {
      this.items = []
      this.totalItems = 0
      this.pagination = {
        hasMore: false,
        page: 1,
        rowsPerPage: 10,
      }
    },
    formatedName(data) {
      if (!data) return '--'
      return `${data.name} ${data.lastname1}`
    },
  },
}
</script>
